module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builder__heading"
  }, [_c('div', {
    staticClass: "builder__title"
  }, [_c('h1', [_c('span', {
    staticClass: "builder__title-main"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), (_vm.product.subtitle) ? _c('span', {
    staticClass: "builder__title-sub"
  }, [_vm._v("- " + _vm._s(_vm.product.subtitle))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.titleAdditions), function(add) {
    return _c('span', {
      key: add,
      staticClass: "builder__title-add"
    }, [_vm._v(" | " + _vm._s(add))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "builder__price",
    domProps: {
      "innerHTML": _vm._s(_vm.price)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a9f4226"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Heading.vue
// module id = 376
// module chunks = 0